export type TMovement = { symbol: string; from: TCoordinate; to: TCoordinate };
export type TCoordinate = { reel: number; row: number };
export type TRandomWild = { symbol: string; coordinates: TCoordinate };
export type TCoin = {
  symbol: string;
  coordinates: TCoordinate;
  multiplier: number;
};
export type TWin = {
  symbol: string;
  win: number;
  odd: number;
  coordinates: TCoordinate[];
  payline?: number;
  multiplier?: number;
};
export type TPaytable = {
  [key: string]: number[];
};

export interface ISymbolData {
  type: string;
  coordinates: TCoordinate;
}

export type TRigEntry = {
  panel: string[][];
  coins?: TCoin[];
  randomWilds?: TRandomWild[];
};

export type TRigData = {
  [key: string]: TRigEntry;
};

export enum EGameState {
  MAIN = "MAIN",
  MAIN_TO_BONUS = "MAIN_TO_BONUS",
  BONUS = "BONUS",
  BONUS_TO_MAIN = "BONUS_TO_MAIN",
  MAIN_TO_HOLD = "MAIN_TO_HOLD",
  HOLD = "HOLD",
  HOLD_TO_MAIN = "HOLD_TO_MAIN",
  BONUS_TO_HOLD = "BONUS_TO_HOLD",
  HOLD_TO_BONUS = "HOLD_TO_BONUS",
}

export type Coordinate = { reel: number; row: number };
export type Coin = {
  symbol: string,
  coordinates: Coordinate,
  multiplier: number
};

export type TInitialResponse = {
  panel: string[][];
  panelNew: string[][];
  bet: number;
  state: EGameState;
  balance: number;
  currencyCode: string;
  maxWin: number;
  bets: number[];
  paylines?: number[][];
  paytable: TPaytable;
  rigData: TRigData;
};

export type TSpinResponse = {
  panel: string[][];
  panelNew: string[][];
  balance: number;
  roundWin: number;
  totalWin: number;
  holdspins: number;
  freespins: number;
  coins: Coin[];
  scattersCollected?: number;
  retriggerFreespins?: number;
  odd: number;
  multiplier?: number;
  state: EGameState;
  wins: TWin[];
  scatterWins?: TWin[];
  randomWilds?: TRandomWild[];
  scatters?: TWin;
  movements?: TMovement[];
  cascade?: TMovement[];
  expandedWilds?: TCoordinate[];
};
